<template>
  <div class="mt-5" v-if="products.length">
    <h2>Legg till dato</h2>
    <p>
      Velg opplevelse, oppgi antall deltakere, start og slutt-tid, bookingfrist, samt tilgjengelig
      dato. Trykk så på Lagre dato.
    </p>
    <div class="d-flex justify-content-between">
      <b-button :to="{ name: 'bookings' }" variant="secondary" size="sm" class="mb-2">
        Tilbake
      </b-button>
    </div>
    <b-card no-body>
      <b-tabs pills card vertical nav-wrapper-class="w-30">
        <b-tab
          v-for="product in products"
          :key="product.id"
          :title="`${product.product_info.name} - ${product.place.name}`"
          active
        >
          <b-card-text>
            <add-dates-to-product :product="product" />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddDatesToProduct from '@/components/booking/AddDatesToProduct.vue';

export default {
  components: {
    AddDatesToProduct,
  },
  mounted() {
    if (this.products.length === 0) {
      this.getProducts();
    }
  },
  computed: {
    ...mapGetters({
      products: 'products/activeProductsNotGrouped',
    }),
  },
  methods: {
    ...mapActions({
      getProducts: 'products/getProducts',
    }),
  },
};
</script>

<style>
</style>
